import React, { Component, useState, useEffect } from 'react';
import './Manage.css';
import '../components/DataTables.css';
import withAuth from '../components/Login/withAuth';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const DeviceTypes = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [types, setTypes] = useState([]);

    const getData = async () => {
        const [devices, functions] = await Promise.all([
            import("../data/devices.js"),
            import("../Functions")
        ])

        const data = await devices.getDeviceTypes();
        setTypes(data);
        functions.initDataTable();
    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <React.Fragment>
            <div className='loc_content'>
                <h1>{t('devices')}</h1>
                <div className="DataTable_Container">
                    <table id="DataTable" class="table responsive nowrap">
                        <thead>
                            <tr class="rowtitle">
                                <th>{t('id')}</th>
                                <th>{t('name')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {types.map((type, i) => {
                                return (
                                    <tr onClick={() => { navigate(`/manage/devices/object/${type.devicetypeid}`) }}>
                                        <td>{type.devicetypeid}</td>
                                        <td>{type.devicetypename}</td>
                                    </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withAuth(DeviceTypes);